import { Screen } from '../interfaces';
export const postassessment: Screen = {
  component: 'assessment',
  key: 'post'
};
